import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => Text,
    _customProps: {
      Component: FDHeadlineText, size: 'lg', align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['disclaimerText'], {
    _component: () => Text,
    _customProps: {
      Component: FDBodyText, size: 'sm', align: 'center', color: 'textDisabled',
    },
  }, overrideReadOnly);
